// extracted by mini-css-extract-plugin
export default {"section":"RoundedSection__section-dLK7","withTopLedge":"RoundedSection__withTopLedge-Uk4B","withBottomLedge":"RoundedSection__withBottomLedge-wU6D"};